<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="clipFrame">
        <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      </clipPath>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g clip-path="url(#clipFrame)">
        <g class="flat-bg" ref="flat-bg">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/tsegi/FlatBg-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/tsegi/FlatBg-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/tsegi/FlatBg-1280w.jpg`" media="(max-width: 1280px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/tsegi/FlatBg.jpg`" />
            </picture>
          </foreignObject>
        </g>
      </g>
      <g class="grass" v-bind:class="{ slow }" ref="grass">
        <image width="4175" height="2444" x="0" y="562" :xlink:href="`${publicPath}scenes/tsegi/Tsegi2.png`"/>
        <image width="3961" height="1255" x="55" y="1666" :xlink:href="`${publicPath}scenes/tsegi/Tsegi3.png`"/>
        <image width="3909" height="1244" x="51" y="1651" :xlink:href="`${publicPath}scenes/tsegi/Tsegi4.png`"/>
        <image width="3961" height="1220" x="18" y="1680" :xlink:href="`${publicPath}scenes/tsegi/Tsegi5.png`"/>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width=".4" :tx="1" :ty=".28">
      Max and Gertie settled in Tsegi Canyon. That way Gertie could stay close
      to her parents. They settled in together. Max was the only person in
      Tsegi with a mule-drawn cart. He used to move the alfalfa he grew
      himself that way. He was also the only one in Tsegi who knew how to grow
      it—I think he picked it up at Haskell. He also took a second job
      translating for the Census.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/tsegi/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    canvasWidth: 4175,
    canvasHeight: 3006,
    slow: false,
    dy: 0,
  }),
  props: ["slide"],
  extends: Template,
  mounted() {
    const scene = this.$refs["scene"]
    const grass = this.$refs["grass"]
    const d = this.$refs["dialogue"].$el
    // this.tl = new TimelineLite({paused: true})
    TweenLite.set(scene, {opacity: 0})
    TweenLite.set(d, {opacity: 0})
    this.tl.add(TweenLite.to(scene, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}))
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  },
}
</script>

<style lang="scss">
.grass {
  image {
    animation-name: grass; animation-iteration-count: infinite;
    animation-timing-function: steps(0, end); animation-duration: 0.8s;
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.2s; }
    &:nth-of-type(3) { animation-delay: -.4s; }
    &:nth-of-type(4) { animation-delay: -.6s; }
  }
  &.slow { image { animation-duration: 1.6s; } }
}
@keyframes sky {
  to { transform: translateX(0px); }
}
@keyframes grass {
  0% { opacity: 1 }
  25% { opacity: 0 }
  50% { opacity: 0 }
}
</style>
